export const toNamespacedKey = (...args) => args.join('/');